<mat-accordion [multi]="false">
    <div class="accordion">
        <mat-expansion-panel #p class="expansion-panel" [expanded]="expanded" (opened)="onOpened()">
            <mat-expansion-panel-header class="expansion-header">
                <mat-panel-title class="expansion-header-title">{{panelHeader}} </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="content">
                <section>
                    <!-- Debug: {{blocks | json}} -->
                    <ng-container *ngFor="let b of (blocks || [])">
                        <!-- Debug block: {{b | json}} -->
                        <ng-container *ngIf="b.paragraph">
                            <app-para [isSinglePara]="true" [para]="b.paragraph"></app-para>
                        </ng-container>
                        <ng-container *ngIf="b.tableHeadings">
                            <app-table [displayedColumns]="b.tableHeadings" [tableData]="b.tableData"
                                [tableUrls]="b.tableUrls" [hasLinks]="true" [tableType]="b.tableType"
                                [usePortalBaseForRelativeLinks]="usePortalBaseForRelativeLinks">
                            </app-table>
                        </ng-container>

                        <ng-container *ngIf="b.items">
                            <app-list [listItems]="b.items"></app-list>
                        </ng-container>
                        <ng-container *ngIf="b.type==='resources'">
                            <div *ngFor="let d of b.data">
                                <app-resources-list [titlesList]="getResourcesList(d)"></app-resources-list>
                            </div>
                        </ng-container>
                    </ng-container>
                </section>
            </div>
        </mat-expansion-panel>

    </div>
</mat-accordion>